import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
	BasicSelect
} from 'vue-search-select'

export default {
	name: 'group-mapping',
	components: {
		BasicSelect,
		VueElementLoading
	},
	props: [],
	data() {
		return {
			isLoadingSearch:false,
			hublist:[],
			hubitem: {
				value: '',
				text: ''
			},
			hub: '',
			hubzonelist: [],
			hubzoneitem: {
				id: '',
				text: ''
			},
			hubzone:'',
			hubzoneLoading: '',
			hubLoading:'',
			rackLoading:'',
			groupLoading:'',
			grouplist: [],
			groupitem: {
				id: '',
				text: ''
			},
			groupid:'',
			rackid:'',
			racklist:[],
			rackitem:{
				id:'',
				text:''
			},
			PTLDetails:[],
			createdBy:'',
			invalidTokenModal: false,
      invalidtokenmsg: '',
			checkMapModel:false,
			inputData:{}

		}
	},
	computed: {

	},
	filters: {
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdBy = userdetail[0].email;
		this.getHubZone();

	},
	methods: {
		getHubZone() {
			this.hubzoneLoading = 'Loading Hub Zone...'
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				// hubName: this.hubzoneitem.id,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubzone/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubzoneLoading = ''
					this.HubZoneListData = result.data.ResponseData;
					for (i = 0; i < this.HubZoneListData.length; i++) {
						this.hubzonelist.push({
							id: this.HubZoneListData[i].hubzoneid,
							text: this.HubZoneListData[i].hubzonename
						})
					}
				}, error => {
					console.error(error)
				})
		},
		selectHubZone(hubzoneitem) {
			this.hubzoneitem = hubzoneitem
			this.hubzone = this.hubzoneitem.id
			// this.hubzoneid = this.hubzoneitem.id

			if (this.hubzone != undefined) {
				this.getHubList(this.hubzone)
			}
		},
		getHubList(data) {
			this.hubLoading = 'Loading Hub...'
			this.hublist = []
			this.hubitem={
				value:'',
				text:''
			}
			this.hub=''
			this.input = ({hubZoneId: data})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading=''
					var HubDetails = result.data.ResponseData
					for (var i = 0; i < HubDetails.length; i++) {
						this.hublist.push({
							"value": HubDetails[i].HubID,
							"text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
						})
					}
				}, error => {
					console.error(error)
				})
		},
		selectHub(hubitem) {
			this.hubitem = hubitem
			this.hub = hubitem.value
			// this.hubID = hubitem.value
			if (this.hub != undefined) {
				this.getGroups()
			}
		},
		selectGroup(groupItem){
			this.groupitem=groupItem
			this.groupid=groupItem.id
			// if (this.hub != undefined) {
			// 	this.getRacks(this.groupid)
			// }
		},
		selectRack(rackItem){
			this.rackitem=rackItem
			this.rackid=rackItem.id
		},
		onSubmit: function() {
			var self = this
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}else{
					this.getRacks()
				}
			}).catch(() => {
				console.log('errors exist')
			});
		},
		openConfirmationModel(data)
		{
			this.inputData=data;
			this.checkMapModel=true;
		},
		closeConfirmationModel()
		{
			this.checkMapModel=false;
			$(document.body).removeClass("modal-open");
			$(".modal-backdrop").remove();
		},
		mapNewRackToPTL() {
			this.input={
				groupId:this.groupid,
				createdBy:this.createdBy,
				rackId:this.inputData.rackid
			}
		axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'mapNewRackToPTL',
				data:this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
					'requestfrom': "WEB",
					'token': this.token
				}
			})
			.then(result => {
				this.closeConfirmationModel();
				if (result.data.ResultCode == 100) {
					this.invalidTokenModal = false
					this.getRacks();
					this.PTLDetails=result.data.ResponseData
					this.$alertify.success(result.data.ReturnMessage);
				} else if (result.data.ResultCode == 401) {
					this.invalidTokenModal = true
					this.invalidtokenmsg = result.data.ReturnMessage
					this.$alertify.error(result.data.ReturnMessage)
				} else {
					this.invalidTokenModal = false
					this.$alertify.error(result.data.ReturnMessage);
				}
			}, error => {
				console.error(error)
			})
	},
			getGroups() {
				this.grouplist=[]
				this.groupitem={
					id:'',
					text:''
				}
				this.group=''
				this.input={
					zoneId:this.hubzone,
					currentHubId:this.hub
				}
				this.$validator.reset();
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'getGroups',
					data:this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
						'requestfrom': "WEB",
						'token': this.token
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.invalidTokenModal = false
						let grouplist=result.data.ResponseData
						for (var i = 0; i < grouplist.length; i++) {
							this.grouplist.push({
								"id": grouplist[i].groupId,
								"text": grouplist[i].groupName,
							})
						}
						this.groupLoading=''
						// this.$alertify.success(result.data.ReturnMessage);
					}else if (result.data.ResultCode == 401) {
						this.invalidTokenModal = true
						this.invalidtokenmsg = result.data.ReturnMessage
						this.$alertify.error(result.data.ReturnMessage)
					}  else {
						this.invalidTokenModal = false
						this.groupLoading='Group details not found'
						// this.$alertify.error(result.data.ReturnMessage);
					}
				}, error => {
					console.error(error)
				})
		},
		getRacks() {
			this.racklist=[]
			this.rackitem={
				id:'',
				text:''
			}
			this.rackid=''
			this.$validator.reset();
		axios({
				method: 'GET',
				url: apiUrl.api_url_hubops + 'getGroupRackList?groupId='+ this.groupid,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
					'requestfrom': "WEB",
					'token': this.token
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {
					this.invalidTokenModal = false
					this.racklist=result.data.ResponseData
					// this.$alertify.success(result.data.ReturnMessage);
				}else if (result.data.ResultCode == 401) {
					this.invalidTokenModal = true
					this.invalidtokenmsg = result.data.ReturnMessage
					this.$alertify.error(result.data.ReturnMessage)
				}  else {
					this.$alertify.error(result.data.ReturnMessage)
					this.invalidTokenModal = false
					this.rackLoading='Rack details not found'
					// this.$alertify.error(result.data.ReturnMessage);
				}
			}, error => {
				console.error(error)
			})
	},
	logout(e) {
		localStorage.removeItem('permissiondata')
		localStorage.removeItem('userdetail')
		localStorage.removeItem('userToken')
		localStorage.removeItem('isLoggedIn')
		localStorage.removeItem('loginDate')
		this.$router.push('/login')
		e.preventDefault()
	},
	closeinvalidTokenModal() {
		this.invalidTokenModal = false
		this.invalidtokenmsg = ''
	},
		resetForm(){
			this.hubzoneLoading=''
			this.groupLoading=''
			this.hubLoading=''
			this.rackLoading=''
		 	this.isLoadingSearch= false;
		 	this.hubzone=''
		 	this.hubzoneitem={
			 	value:'',
			 	text:''
		 	}
		 	this.hub=''
		 	this.hubitem={
			 	value:'',
			 	text:''
		 	}
		 	this.hublist=[]
		 	this.groupid=''
		 	this.grouplist=[]
		 	this.groupitem={
			 	id:'',
			 	text:''
		 	}
			this.rackid=''
			this.rackitem={
				id:'',
				text:''
			}
			this.racklist=[]
			this.PTLDetails=[]
		 	this.$validator.reset();
	 }
	}
}



// WEBPACK FOOTER //
// ./src/views/components/PTLMapping/RackMapping/RackMapping.js